import React from 'react';
import './Footer.css'; 

function Footer({ setView }) {
  const handleNavClick = (page) => {
    setView(page);
    window.scrollTo(0, 0); // পেজ চেঞ্জ হলে একদম উপরে চলে যাবে
  };

  return (
    <footer className="footer-container">
      <div className="footer-grid">
        
        {/* 🚨 ১. COMPANY SECTION (Legal & Policy এর সাথে মার্জ করা হলো) 🚨 */}
        <div className="footer-card">
          <p style={{ color: '#ef5e33', fontSize: '16px', fontWeight: '900',margin: '5px 10px' }}>COMPANY</p>
          <ul className="footer-list">
            <li onClick={() => handleNavClick('about')}>About Us</li>
            <li onClick={() => handleNavClick('terms')}>Terms & Conditions</li>
            <li onClick={() => handleNavClick('career')}>Career</li>
            
            <li onClick={() => handleNavClick('contact-us')}>Contact Us</li>
          </ul>
        </div>

        {/* 🚨 ২. SERVICES SECTION 🚨 */}
        <div className="footer-card">
          <p style={{ color: '#ef5e33', fontSize: '16px', fontWeight: '900',margin: '5px 10px' }}>SERVICES</p>
          <ul className="footer-list">
            <li onClick={() => handleNavClick('inspection-process')}>Inspection Process</li>
            <li onClick={() => handleNavClick('privacy')}>Privacy Policy</li>
            <li onClick={() => handleNavClick('faq')}>FAQ</li>
            <li onClick={() => handleNavClick('home')}>Customer Review</li>
          </ul>
        </div>

        {/* 🚨 ৩. SOCIAL LINKS (স্টাইলিশ Bah! Car Plaza হেডিং সহ) 🚨 */}
        <div className="footer-card">
          
          <div className="footer-logo-heading">
            Bah! <span>Car Plaza</span>
          </div>
          
          <div className="social-icons">
            <a href="https://m.facebook.com/profile.php?id=61583794865972" className="social-icon fb">fb</a>
            <a href="https://x.com/BahCarPlaza" className="social-icon x">𝕏</a>
            <a href="https://www.instagram.com/bahcarplaza" className="social-icon insta">📸</a>
            <a href="https://youtube.com/@bahcarplaza?si=aljkH2G834fmQy03" className="social-icon yt">▶</a>
            <a href="#!" className="social-icon in">in</a>
          </div>
          
          <div className="app-buttons">
            <img src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg" alt="App Store" className="app-btn" />
            <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" alt="Google Play" className="app-btn" />
          </div>
        </div>

      </div>

      <div className="footer-bottom">
        © 2026 Bah! Car Plaza. Designed for premium users. All rights reserved.
      </div>
    </footer>
  );
}

export default Footer;